export class ProjectChecklistResult {
    public id: number = 0;
    public name: string = '';
    public description = '';
    public order = 0;
    public projectId = 0;
    public projectName = '';
    public isDeleted: boolean = false;
}
